/* You Fly LA kit (yk-) v66 :: yk-story.js :: built from kit/src */
/* --- 20-story-0-base.js --- */
/* =====================================================================
   YFLA KIT story group (KB2-STORY, v66): shared helpers + run-once guard.
   window.YK_story is the group flag: a second copy of assets/yk-story.js
   (two snippets on one page each print the <script>) does nothing.
   Every later 20-story-* file registers once (S.<name> flags).
   ===================================================================== */
(function () {
  'use strict';
  if (window.YK_story) return;
  var S = window.YK_story = { v: 'v66' };

  /* assets/yk-core.js may run after this file: wait for YK.reg, then register. */
  S.ready = function (fn) {
    if (window.YK && window.YK.reg) { fn(window.YK); return; }
    var n = 0, t = setInterval(function () {
      if (window.YK && window.YK.reg) { clearInterval(t); fn(window.YK); }
      else if (++n > 400) clearInterval(t);
    }, 25);
  };

  /* Headings that belong to the page copy itself: not inside a kit element, an aside, a table,
     a disclosure or a page-plus card. Kit elements placed in the copy keep their own headings out. */
  S.SKIP = '.yk, aside, nav, table, details, dialog, figure, .pp-cta, [data-yk-skip]';
  S.h2s = function (box) {
    return Array.prototype.filter.call(box.querySelectorAll('h2'), function (h) {
      var c = h.closest(S.SKIP);
      if (c && c !== box && box.contains(c)) return false;
      return (h.textContent || '').trim() !== '' && h.getClientRects().length > 0;
    });
  };
  S.pad = function (n) { return (n < 10 ? '0' : '') + n; };

  /* Same id rule as sections/yfla-page-plus.liquid's "On This Page" list, so both point at one id. */
  S.slug = function (h, i) {
    var id = h.getAttribute('id');
    if (id) return id;
    var base = (h.textContent || '').toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '').slice(0, 64) || ('section-' + (i + 1));
    id = base;
    var n = 2;
    while (document.getElementById(id)) { id = base + '-' + n; n++; }
    h.setAttribute('id', id);
    return id;
  };

  /* Height of the site header that sticky parts sit under (core sets --yk-head on <html>). */
  S.head = function () {
    var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--yk-head'));
    return isNaN(v) ? 64 : v;
  };

  /* Bring an element's top below the header when it is above it (user actions only, never at load). */
  S.reveal = function (el, YK) {
    if (!el) return;
    var top = S.head() + 12, r = el.getBoundingClientRect();
    if (r.top < top) S.scrollTo(YK, r.top + S.scrollY(YK) - top, YK.reduced() ? 'auto' : 'smooth');
  };

  /* Page scroll position / scroll / listener through core's page-scroller helpers (QA-V66: at >= 990px
     .page-wrapper scrolls, not the window); plain window fallbacks if an older core is cached. */
  S.scrollY = function (YK) { return YK.scrollY ? YK.scrollY() : (window.pageYOffset || 0); };
  S.scrollTo = function (YK, top, behavior) {
    if (YK.scrollTo) YK.scrollTo(top, behavior);
    else window.scrollTo({ top: Math.max(0, Math.round(top)), behavior: behavior });
  };
  S.onScroll = function (YK, fn) {
    if (YK.onScroll) YK.onScroll(fn); else window.addEventListener('scroll', fn, { passive: true });
  };

  /* Arrow / Home / End between a list of headers (accordion pattern). Returns the new index or -1. */
  S.keys = function (n, e, i) {
    switch (e.key) {
      case 'ArrowDown': case 'ArrowRight': return (i + 1) % n;
      case 'ArrowUp': case 'ArrowLeft': return (i - 1 + n) % n;
      case 'Home': return 0;
      case 'End': return n - 1;
      default: return -1;
    }
  };
})();

/* --- 20-story-1-chapters.js --- */
/* ---------------------------------------------------------------------
   Enhancer `chapters` (design 02 Editorial): on a copy container with
   data-yk-enhance="chapters" and 3+ H2s, each H2 gets data-yk-ch="01"…
   (printed by CSS as a mono numeral over a hairline: the heading's text
   is never touched) and the first long plain paragraph gets a drop cap.
   --------------------------------------------------------------------- */
(function () {
  'use strict';
  var S = window.YK_story;
  if (!S || S.chapters) return;
  S.chapters = 1;
  S.ready(function (YK) {
    YK.enh('chapters', function (box) {
      var hs = S.h2s(box);
      if (hs.length < 3) return;
      box.classList.add('yk-e-chapters');
      hs.forEach(function (h, i) {
        h.classList.add('yk-e-ch');
        h.setAttribute('data-yk-ch', S.pad(i + 1));
      });
      /* drop cap: the first plain paragraph (of the first three) that is long and starts with a letter */
      var ps = box.querySelectorAll('p'), seen = 0;
      for (var i = 0; i < ps.length && seen < 3; i++) {
        var p = ps[i], c = p.closest(S.SKIP + ', blockquote, li, td, th, .yfla-note');
        if (c && c !== box && box.contains(c)) continue;
        var t = (p.textContent || '').replace(/\s+/g, ' ').trim();
        if (!t) continue;
        seen++;
        if (t.length < 140 || !/^[A-Za-z]/.test(t)) continue;
        var f = p.firstChild;
        while (f && f.nodeType === 3 && !f.nodeValue.trim()) f = f.nextSibling;
        if (!f || (f.nodeType !== 3 && !/^(EM|STRONG|B|I|SPAN)$/.test(f.nodeName))) continue;
        p.classList.add('yk-e-drop');
        break;
      }
    });
  });
})();

/* --- 20-story-2-subnav.js --- */
/* ---------------------------------------------------------------------
   Enhancer `subnav` + element `subnav` (design 03 frosted sub-nav).
   Built from the copy's H2s (4 or more), placed at the top of the copy,
   sticky at top: var(--yk-head) so it never slides under the site
   header, scroll-spy marks the current section (aria-current), chips
   scroll inside their own strip on phones. One per page.
   snippets/yk-subnav.liquid prints a hidden shell (labels + CTA); without
   it the enhancer builds the same shell.
   --------------------------------------------------------------------- */
(function () {
  'use strict';
  var S = window.YK_story;
  if (!S || S.subnav) return;
  S.subnav = 1;
  var CTA = {
    consult: ['Free Consultation', '', '/pages/book-a-consultation'],
    discovery: ['Book', '$229', '/products/discovery-flight-los-angeles'],
    lesson: ['Book', '$349', '/products/beginner-flying-lesson-los-angeles']
  };

  function shell(cta) {
    var nav = document.createElement('nav'), c = CTA[cta];
    nav.className = 'yk yk-subnav';
    nav.setAttribute('aria-label', 'On This Page');
    nav.hidden = true;
    nav.innerHTML = '<div class="yk-subnav__in"><span class="yk-subnav__n" aria-hidden="true"></span>' +
      '<div class="yk-subnav__links" data-yk-scroll></div>' +
      (c ? '<a class="yk-btn yk-btn--primary yk-btn--sm yk-subnav__cta" href="' + c[2] + '" data-yk-track="subnav-' + cta + '">' +
        c[0] + (c[1] ? ' <span class="yk-mono">' + c[1] + '</span>' : '') + '</a>' : '') + '</div>';
    return nav;
  }

  /* chip label: the heading up to its first " — " or ": " (Step 1: … -> Step 1), else the heading */
  function short(t) {
    var s = t.split(/\s+[—–-]\s+|:\s+/)[0];
    return s.length >= 4 ? s : t;
  }

  function build(YK, box, nav) {
    if (S.subnavEl) {
      if (nav && nav !== S.subnavEl && nav.parentNode) nav.parentNode.removeChild(nav);
      return;
    }
    var hs = S.h2s(box);
    if (hs.length < 4) return;
    var no = nav ? YK.opts(nav) : {}, bo = YK.opts(box);
    if (bo.subnav && typeof bo.subnav === 'object') bo = bo.subnav;
    var labels = no.labels || bo.labels || [];
    if (!nav) nav = shell(bo.cta === 'none' ? '' : (CTA[bo.cta] ? bo.cta : 'consult'));
    S.subnavEl = nav;
    nav.__ykBuilt = true;

    /* top of the copy, in a block box, so the sticky bar travels the whole copy and stops at its end */
    var host = box;
    while (host.parentElement && /^(inline|contents)$/.test(getComputedStyle(host).display)) host = host.parentElement;
    host.insertBefore(nav, host.firstChild);

    var list = nav.querySelector('.yk-subnav__links'), num = nav.querySelector('.yk-subnav__n');
    var numbered = box.classList.contains('yk-e-chapters') || /(^|\s)chapters(\s|$)/.test(box.getAttribute('data-yk-enhance') || '');
    var links = hs.map(function (h, i) {
      var id = S.slug(h, i);
      h.classList.add('yk-e-sn');
      var full = (h.textContent || '').replace(/\s+/g, ' ').trim();
      var lab = (labels[i] && String(labels[i]).trim()) || short(full);
      var a = document.createElement('a');
      a.className = 'yk-subnav__a';
      a.href = '#' + id;
      if (lab !== full && full.indexOf(lab) === 0) a.setAttribute('aria-label', full);
      if (lab !== full) a.title = full;
      a.innerHTML = (numbered ? '<span class="yk-subnav__num" aria-hidden="true">' + S.pad(i + 1) + '</span>' : '') + '<span class="yk-subnav__t"></span>';
      a.lastChild.textContent = lab;
      a.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
        e.preventDefault();
        var y = h.getBoundingClientRect().top + S.scrollY(YK) - ((S.subnavHead ? S.subnavHead() : S.head()) + nav.offsetHeight + 16);
        S.scrollTo(YK, y, YK.reduced() ? 'auto' : 'smooth');
        if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1');
        try { h.focus({ preventScroll: true }); } catch (x) { /* old browsers */ }
        try { history.replaceState(history.state, '', '#' + id); } catch (x) { /* file:// */ }
        YK.track('subnav', id);
      });
      list.appendChild(a);
      return a;
    });
    /* page-plus already shows a sticky "On This Page" list beside the copy on desktop: no second one there */
    if (document.querySelector('.pp-aside .pp-toc')) nav.classList.add('yk-subnav--pp');
    nav.hidden = false;

    /* The bar follows the header's real bottom edge on every frame (a header that hides on scroll down and
       comes back on scroll up never covers it); core's --yk-head (CSS) is the fallback before the first frame. */
    var cands = YK.qsa('#header-group, #header-group *').filter(function (n) {
      return n.children.length <= 40 && /^(fixed|sticky)$/.test(getComputedStyle(n).position);
    });
    var lastTop = -1;
    function headTop() {
      var h = 0;
      if (YK.headH) h = YK.headH(); /* QA-V66: the same edge core uses for --yk-head (the visible header bar) */
      else {
        if (!cands.length) return S.head();
        cands.forEach(function (n) {
          var r = n.getBoundingClientRect();
          if (r.height > 0 && r.height < 220 && r.top <= 1 && r.bottom > h) h = r.bottom;
        });
      }
      h = Math.max(0, Math.round(h));
      if (h !== lastTop) { nav.style.top = h + 'px'; lastTop = h; }
      return h;
    }
    S.subnavHead = headTop;
    var cur = -2, queued = false;
    function set(i) {
      if (i === cur) return;
      cur = i;
      links.forEach(function (a, j) {
        if (j === i) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      });
      num.textContent = S.pad(Math.max(i + 1, 0)) + ' / ' + S.pad(hs.length);
      if (i < 0) return;
      var a = links[i], x = Math.max(0, a.offsetLeft - (list.clientWidth - a.offsetWidth) / 2);
      if (Math.abs(list.scrollLeft - x) > 2) {
        if (list.scrollTo) list.scrollTo({ left: x, behavior: YK.reduced() ? 'auto' : 'smooth' }); else list.scrollLeft = x;
      }
    }
    function spy() {
      queued = false;
      var line = headTop() + nav.offsetHeight + 28, i = -1;
      for (var j = 0; j < hs.length; j++) {
        if (hs[j].getBoundingClientRect().top <= line) i = j; else break;
      }
      set(i);
    }
    function q() { if (!queued) { queued = true; requestAnimationFrame(spy); } }
    S.onScroll(YK, q);
    window.addEventListener('resize', q, { passive: true });
    spy();
  }

  S.ready(function (YK) {
    /* the snippet shell: built here only when no copy container asks for the enhancer itself */
    YK.reg('subnav', function (nav) {
      if (nav.__ykBuilt || document.querySelector('[data-yk-enhance~="subnav"]')) return;
      var box = document.querySelector('[data-yk-enhance]') || document.querySelector('.page-content, .rte, article');
      if (box) build(YK, box, nav);
    });
    YK.enh('subnav', function (box) {
      var nav = null;
      YK.qsa('nav.yk-subnav').some(function (n) { if (!n.__ykBuilt) { nav = n; return true; } return false; });
      build(YK, box, nav);
    });
  });
})();

/* --- 20-story-4-reviews.js --- */
/* ---------------------------------------------------------------------
   yk-reviews: topic filter chips (aria-pressed) and Read More on clamped
   reviews (aria-expanded). Without JS every review shows in full.
   --------------------------------------------------------------------- */
(function () {
  'use strict';
  var S = window.YK_story;
  if (!S || S.reviews) return;
  S.reviews = 1;
  S.ready(function (YK) {
    YK.reg('reviews', function (el) {
      var cards = YK.qsa('.yk-reviews__card', el), chips = YK.qsa('[data-f]', el), status = el.querySelector('[data-yk-status]');
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          var f = c.getAttribute('data-f'), n = 0;
          chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
          cards.forEach(function (card) {
            var show = f === 'all' || (' ' + card.getAttribute('data-t') + ' ').indexOf(' ' + f + ' ') > -1;
            card.hidden = !show;
            if (show) n++;
          });
          if (status) status.textContent = 'Showing ' + n + (n === 1 ? ' Review' : ' Reviews');
          check();
          YK.track('reviews_filter', f);
        });
      });
      YK.qsa('.yk-reviews__more', el).forEach(function (b) {
        b.addEventListener('click', function () {
          var q = document.getElementById(b.getAttribute('aria-controls'));
          var open = !q.classList.contains('is-open');
          q.classList.toggle('is-open', open);
          b.setAttribute('aria-expanded', open ? 'true' : 'false');
          b.textContent = open ? 'Read Less' : 'Read More';
        });
      });
      /* show Read More only where the six-line clamp actually cuts the review */
      function check() {
        YK.qsa('.yk-reviews__more', el).forEach(function (b) {
          var q = document.getElementById(b.getAttribute('aria-controls'));
          if (!q || q.classList.contains('is-open')) return;
          b.hidden = !(q.scrollHeight > q.clientHeight + 2);
        });
      }
      var t;
      requestAnimationFrame(check);
      window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(check, 150); }, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
    });
  });
})();

/* --- 20-story-5-why.js --- */
/* ---------------------------------------------------------------------
   yk-why: one reason open at a time (aria-expanded), the photo crossfades
   to it; arrow keys / Home / End move between the six headers.
   --------------------------------------------------------------------- */
(function () {
  'use strict';
  var S = window.YK_story;
  if (!S || S.why) return;
  S.why = 1;
  S.ready(function (YK) {
    YK.reg('why', function (el) {
      var items = YK.qsa('.yk-why__item', el), imgs = YK.qsa('.yk-why__img', el);
      var btns = items.map(function (it) { return it.querySelector('.yk-why__b'); });
      function open(i) {
        items.forEach(function (it, j) {
          it.classList.toggle('is-open', j === i);
          btns[j].setAttribute('aria-expanded', j === i ? 'true' : 'false');
        });
        imgs.forEach(function (im, j) {
          im.classList.toggle('is-on', j === i);
          im.setAttribute('aria-hidden', j === i ? 'false' : 'true');
        });
      }
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { open(i); YK.track('why', String(i + 1)); });
        b.addEventListener('keydown', function (e) {
          var j = S.keys(btns.length, e, i);
          if (j > -1) { e.preventDefault(); btns[j].focus(); }
        });
      });
      var start = 0;
      items.forEach(function (it, j) { if (it.classList.contains('is-open')) start = j; });
      open(start);
    });
  });
})();

/* --- 20-story-6-nextsteps.js --- */
/* ---------------------------------------------------------------------
   yk-nextsteps: one panel open at a time (aria-expanded); a closed panel
   opens from its header button or a click anywhere on it; arrow keys /
   Home / End move between the four headers.
   --------------------------------------------------------------------- */
(function () {
  'use strict';
  var S = window.YK_story;
  if (!S || S.nextsteps) return;
  S.nextsteps = 1;
  S.ready(function (YK) {
    YK.reg('nextsteps', function (el) {
      var panels = YK.qsa('.yk-ns__panel', el);
      var btns = panels.map(function (p) { return p.querySelector('.yk-ns__b'); });
      function open(i) {
        panels.forEach(function (p, j) {
          p.classList.toggle('is-on', j === i);
          btns[j].setAttribute('aria-expanded', j === i ? 'true' : 'false');
        });
      }
      panels.forEach(function (p, i) {
        p.addEventListener('click', function (e) {
          if (p.classList.contains('is-on') || (e.target.closest && e.target.closest('a'))) return;
          open(i);
          YK.track('nextsteps', String(i + 1));
        });
        btns[i].addEventListener('keydown', function (e) {
          var j = S.keys(btns.length, e, i);
          if (j > -1) { e.preventDefault(); btns[j].focus(); }
        });
      });
      var start = 0;
      panels.forEach(function (p, j) { if (p.classList.contains('is-on')) start = j; });
      open(start);
    });
  });
})();

/* --- 20-story-7-quiz.js --- */
/* ---------------------------------------------------------------------
   yk-quiz: five questions, Back, progress ticks, Start Over; the outcome
   is chosen by the eleven rules of home5/content.json
   (yh-quiz.recommend_rules_in_order), matched on the answer labels.
   Option `start` (myself | gift | child | exploring) answers question 1.
   --------------------------------------------------------------------- */
(function () {
  'use strict';
  var S = window.YK_story;
  if (!S || S.quiz) return;
  S.quiz = 1;
  /* content.json rules, in order (first match wins) */
  function match(a) {
    var who = a.who, why = a.why, exp = a.exp, bud = a.budget;
    var licensed = exp === 'Already Licensed', career = why === 'A Career As A Pilot', travel = why === 'Freedom To Travel';
    var b10 = bud === '$10,000 – $15,000', b15 = bud === '$15,000 – $50,000', b84 = bud === '$84,000';
    if (who === 'My Child') return 'junior';                                 // who = My Child -> junior
    if (licensed && career && (b15 || b84)) return 'cpl';                    // Licensed + Career + $15k-$50k or $84k
    if (licensed && career) return 'cfi';                                    // Licensed + Career
    if (licensed && travel) return 'ir';                                     // Licensed + Freedom To Travel
    if (licensed) return 'me';                                               // Licensed (anything else)
    if (who === 'A Gift' && why === 'Bucket List') return 'lux';             // A Gift + Bucket List
    if (career && b84) return 'atp';                                         // Career + $84,000
    if (career) return 'pplc';                                               // Career (any other budget)
    if (travel && (b10 || b15)) return 'bundle';                             // Travel + $10k-$15k or $15k-$50k
    if (why === 'A Lifelong Dream' && b10) return 'ppls';                    // Lifelong Dream + $10k-$15k
    return 'disc';                                                           // everything else
  }
  S.quizMatch = match;
  var START = { myself: 0, gift: 1, child: 2, exploring: 3 };

  S.ready(function (YK) {
    YK.reg('quiz', function (el, opts) {
      var qs = YK.qsa('.yk-quiz__q', el), outs = YK.qsa('.yk-quiz__o', el), ticks = YK.qsa('.yk-quiz__ticks i', el);
      var back = el.querySelector('.yk-quiz__back'), stepEl = el.querySelector('.yk-quiz__step'), panel = el.querySelector('.yk-quiz__panel');
      var kicker = (el.querySelector('.yk-quiz__k') || {}).textContent || 'Your Match';
      var N = qs.length, step = 0, ans = {}, timer = null;

      function render(focus) {
        var done = step >= N, key = done ? match(ans) : '';
        qs.forEach(function (q, i) { q.classList.toggle('is-on', i === step); });
        ticks.forEach(function (t, i) { t.classList.toggle('is-on', i <= step); });
        outs.forEach(function (o) { o.classList.toggle('is-on', o.getAttribute('data-o') === key); });
        el.classList.toggle('is-done', done);
        el.setAttribute('data-yk-match', key);
        back.disabled = step === 0;
        stepEl.textContent = done ? kicker : 'Step ' + (step + 1) + ' Of ' + N;
        if (focus) {
          var t = done ? el.querySelector('.yk-quiz__o.is-on .yk-quiz__ot') : qs[step].querySelector('.yk-quiz__qt');
          if (t) { try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); } }
          S.reveal(panel, YK);
        }
      }
      function press(q, b) {
        YK.qsa('.yk-quiz__a', q).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        ans[q.getAttribute('data-key')] = b.getAttribute('data-a');
      }
      qs.forEach(function (q, qi) {
        YK.qsa('.yk-quiz__a', q).forEach(function (b) {
          b.addEventListener('click', function () {
            if (step !== qi) return;
            press(q, b);
            clearTimeout(timer);
            var go = function () { step = qi + 1; render(true); if (step >= N) YK.track('quiz_match', match(ans)); };
            if (YK.reduced()) go(); else timer = setTimeout(go, 160);
          });
        });
      });
      back.addEventListener('click', function () {
        clearTimeout(timer);
        if (step > 0) { step--; render(true); }
      });
      YK.qsa('.yk-quiz__reset', el).forEach(function (b) {
        b.addEventListener('click', function () {
          clearTimeout(timer);
          ans = {};
          step = 0;
          YK.qsa('.yk-quiz__a', el).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          render(true);
          YK.track('quiz_reset', '');
        });
      });
      if (opts && START.hasOwnProperty(opts.start) && qs[0]) {
        var b0 = YK.qsa('.yk-quiz__a', qs[0])[START[opts.start]];
        if (b0) { press(qs[0], b0); step = 1; }
      }
      render(false);
    });
  });
})();
